import { Col, Form, Row, Tooltip } from "antd"
import { useTranslation } from "react-i18next"

import InputNumber from "../../../../../components/Input/InputNumber.tsx"
import { type ProjectFormData } from "../project-form-data.ts"

export function BudgetSummarySection() {
  const { t } = useTranslation()
  const form = Form.useFormInstance()

  const salesPrice = Form.useWatch("sales_price", form)
  const plannedPayable = Form.useWatch("planned_payable", form)

  const margin = (salesPrice ?? 0) - (plannedPayable ?? 0)
  const hasNegativeMargin =
    salesPrice != null && plannedPayable != null && margin < 0

  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData>
            label={t("tabbedForm.fields.salesPrice")}
            name="sales_price"
          >
            <InputNumber
              prefix="$"
              placeholder="0.00"
              step={0.01}
              min={0}
              precision={2}
              maxIntegerDigits={10}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData>
            label={t("tabbedForm.fields.plannedPayable")}
            name="planned_payable"
            validateStatus={hasNegativeMargin ? "warning" : undefined}
            help={
              hasNegativeMargin
                ? t("tabbedForm.fields.plannedPayableExceedsSalesPrice")
                : undefined
            }
          >
            <InputNumber
              prefix="$"
              placeholder="0.00"
              step={0.01}
              min={0}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData> label={t("tabbedForm.fields.marginAuto")}>
            <InputNumber
              prefix="$"
              placeholder="0.00"
              value={margin}
              disabled
              status={hasNegativeMargin ? "warning" : undefined}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData>
            label={
              <Tooltip title={t("tabbedForm.fields.marginMultiplierHint")}>
                <span>{t("tabbedForm.fields.marginMultiplier")}</span>
              </Tooltip>
            }
            name="margin_multiplier"
          >
            <InputNumber
              suffix="x"
              placeholder="3.00"
              step={0.1}
              min={0}
              precision={2}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData>
            label={
              <Tooltip title={t("tabbedForm.fields.marginWarningPercentHint")}>
                <span>{t("tabbedForm.fields.marginWarningPercent")}</span>
              </Tooltip>
            }
            name="margin_warning_percent"
          >
            <InputNumber
              suffix="%"
              placeholder="20"
              step={1}
              min={0}
              max={100}
              precision={2}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
